import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import {
    GenerateDigitalOrderYandexPayWidgetURLMethod,
    type GenerateDigitalOrderYandexPayWidgetURLPathParameters,
    type GenerateDigitalOrderYandexPayWidgetURLResponseSuccess,
    type GenerateDigitalOrderYandexPayWidgetURLSearchParams,
    GetDigitalOrderPaymentContextMethod,
    type GetDigitalOrderPaymentContextPathParameters,
    type GetDigitalOrderPaymentContextResponseSuccess,
    type GetDigitalOrderPaymentContextSearchParams,
    getGenerateDigitalOrderYandexPayWidgetURLUrl,
    getGetDigitalOrderPaymentContextUrl,
} from '@/shared/api/openApi';
import { request } from '@/shared/api/request';

type GeneratePayboxPayURLRequestParams = GenerateDigitalOrderYandexPayWidgetURLSearchParams &
    GenerateDigitalOrderYandexPayWidgetURLPathParameters;

const paymentApi = createApi({
    name: 'entities/digitalOrder/api/paymentApi',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            GeneratePayboxPayURL: builder.query<
                GenerateDigitalOrderYandexPayWidgetURLResponseSuccess,
                GeneratePayboxPayURLRequestParams
            >({
                query: ({ order_id, store_slug, ...payload }) => {
                    return {
                        url: getGenerateDigitalOrderYandexPayWidgetURLUrl({ order_id, store_slug }),
                        method: GenerateDigitalOrderYandexPayWidgetURLMethod,
                        params: payload,
                    };
                },
                keepUnusedDataFor: 0,
            }),

            GetPaymentContext: builder.query<
                Required<GetDigitalOrderPaymentContextResponseSuccess>,
                GetDigitalOrderPaymentContextSearchParams & GetDigitalOrderPaymentContextPathParameters
            >({
                query: ({ order_id, store_slug, ...payload }) => {
                    return {
                        url: getGetDigitalOrderPaymentContextUrl({ order_id, store_slug }),
                        method: GetDigitalOrderPaymentContextMethod,
                        params: payload,
                    };
                },
                keepUnusedDataFor: 0,
            }),
        };
    },
});

export const getOrderPayboxPayURL = (params: GeneratePayboxPayURLRequestParams) =>
    paymentApi.endpoints.GeneratePayboxPayURL.query(params);

export const getPaymentContext = paymentApi.endpoints.GetPaymentContext.query;
